import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { compose, withHandlers, lifecycle, withState } from 'recompose';
import { withRouter } from 'react-router';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import moment from 'moment';
import classNames from 'classnames';
import { isAuthenticated, sendLogin } from '../../auth/Auth';
import { getAccounts, addShopAccount } from '../../actions/Accounts';
import { addShopImage, addRelationShop } from '../../actions/Shop';
import ProgressDialog from '../../components/molecules/ProgressDialog';
import CancelButton from '../../components/atoms/CancelButton';
import {
  getStatisticsCompare,
  postStatisticsGochi,
  postStatisticsImport,
  downloadCSV
} from '../../actions/AutomaticStatistics';
import { getStatisticGochiStatusData } from '../../libs/apis/AutomaticStatisticsApi';

import '../../stylesheets/csv.css';

const styles = {
  root: {
    backgroundColor: '#e0e0e0',
    flexGrow: 1,
    width: '100%'
  },
  btnRun: {
    width: '230px',
    marginLeft: '10px',
    lineHeight: '24px'
  },
  listBtn: {
    marginTop: '40px',
    textAlign: 'center'
  },
  boxCreate: {
    width: '80%',
    margin: '70px auto'
  },
  contentTable: {
    marginTop: '50px',
    marginBottom: '30px',
    maxWidth: '100%',
    overflowY: 'auto'
  },
  titleSection: {
    marginBottom: '20px',
    fontWeight: 'bold'
  },
  subTitleSection: {
    marginTop: '20px',
    marginBottom: 20,
    fontWeight: 'bold'
  },
  boxSum: {
    display: 'flex',
    paddingBottom: '20px'
  },
  boxSumBorder: {
    borderBottom: '2px solid'
  },
  boxSumTitle: {
    width: '70%'
  },
  boxSumData: {
    width: '30%',
    textAlign: 'right'
  },
  box3_bottom: {
    display: 'flex',
    // width: '40%',
    // float: 'right',
    position: 'relative',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginTop: 10
  },
  check_sum: {
    display: 'flex',
    marginTop: '10px',
    marginBottom: '10px'
  },
  title_check_sum: {
    marginRight: '10px'
  },
  box3_bottom_data: {
    fontSize: 20,
    marginLeft: 100
  },
  tableReport: {
    border: '1px solid #e0e0e0'
  },
  noData: {
    textAlign: 'center',
    fontSize: 14
  },
  marginTop: {
    marginTop: 10
  },
  subTitle: {
    marginTop: 10,
    marginBottom: 10
  }
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      prefectures: state.commons.prefectures,
      shopCategories: state.commons.shopCategories
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getAccounts,
          getStatisticsCompare,
          addShopAccount,
          addRelationShop,
          downloadCSV,
          postStatisticsImport,
          postStatisticsGochi,
          addShopImage
        },
        dispatch
      )
    })
  ),
  // withState('sskChargeCountSummary', 'setSskChargeCountSummary', []),
  // withState('sskUserTicketDetailErrors', 'setSskUserTicketDetailErrors', []),
  // withState('chargePaypayAndAllCompare', 'setChargePaypayAndAllCompare', []),
  // withState('sskTicketCountSummary', 'setSskTicketCountSummary', []),
  // withState('gochiAmountOut', 'setGochiAmountOut', []),
  // withState('chargeStripeCompare', 'setChargeStripeCompare', []),
  // withState('transferAmount', 'setTransferAmount', []),
  // withState('chargeIds', 'setChargeIds', []),
  // withState('transferBackOut', 'setTransferBackOut', []),
  // withState('transferBackMenuGroupOut', 'setTransferBackMenuGroupOut', []),
  // withState('chargeStripeAndAllCompare', 'setChargeStripeAndAllCompare', []),
  // withState('chargeNotTransferAmount', 'setChargeNotTransferAmount', []),
  // withState('userHoldingTickets', 'setUserHoldingTickets', []),
  withState('compareData', 'setCompareData', {
    chargeStripeCompare: [],
    chargePaypayCompare: [],
    chargeAlipayCompare: [],
    chargeVeritransCompare: [],
    chargeAtoneCompare: [],
    transferStripeCompare: [],
    transferAmount: [],
    transferStripeAndGochiCompare: [],
    transferBackOut: [],
    transferBackMenuGroupOut: [],
    gochiAmountOut: [],
    sskTicketCountSummary: [],
    sskUserTicketDetailErrors: [],
    chargeNotTransferAmount: [],
    chargeStripeAndAllCompare: [],
    chargeIds: [],
    paypaySummaryOut: {},
    chargePaypayAndAllCompare: [],
    veritransSummaryOut: {},
    chargeVeritransAndAllCompare: [],
    chargeVeritransRefundAndAllCompare: [],
    atoneSummaryOut: {},
    chargeAtoneAndAllCompare: [],
    alipaySummaryOut: {},
    chargeAlipayAndAllCompare: [],
    gochiBillDeleted: [],
    sskChargeCountSummary: [],
    sskUnusedTicket: [],
    sskPaymentAmountCompare: [],
    sskPaymentAmountAndMenuCompare: [],
    userHoldingTickets: []
  }),
  withState('enableBtnImport', 'setEnableBtnImport', false),
  withState('enableBtnReport', 'setEnableBtnReport', false),
  withState('openProgress', 'updateOpenProgress', false),
  withState('loading', 'setLoading', false),
  withState('comparing', 'setComparing', false),
  withState('message', 'setMessage', ''),
  withState('openConfirmDialog', 'updateOpenConfirmDialog', false),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleRedirect: props => path => {
      props.history.push(path);
    }
  }),
  lifecycle({
    componentDidMount() {
      isAuthenticated(this.props);
      this.props.actions.getAccounts({ cognitoUserId: '' }).then(async data => {
        this.props.checkSession(data);
      });
    }
  })
);

const Main = enhance(
  ({
    classes,
    actions,
    compareData,
    setCompareData,
    handleRedirect,
    openProgress,
    updateOpenProgress,
    loading,
    setLoading,
    comparing,
    setComparing,
    message,
    setMessage,
    checkSession,
    openConfirmDialog,
    updateOpenConfirmDialog
  }) => {
    function progressOkAction() {
      updateOpenProgress(false);
    }

    const getDetail = () => {
      // updateOpenConfirmDialog(false);
      // updateOpenProgress(true);
      setComparing(true);
      actions.getStatisticsCompare().then(data => {
        if (data.type === 'GET_STATISTICS_COMPARE_SUCCESS') {
          setComparing(false);
          updateOpenProgress(false);
          setMessage('');
          setCompareData(data.payload);
        } else {
          setComparing(false);
          setMessage('Error when get detail report');
        }
      });
    };
    useEffect(() => {
      getDetail();
    }, []);

    const downloadCsvBlob = (blob, fileName) => {
      if (window.navigator.msSaveOrOpenBlob) {
        // for IE,Edge
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        // for chrome, firefox
        const bl = new Blob([blob], {
          type: 'application/octet-stream'
        });
        const url = URL.createObjectURL(bl);
        const linkEl = document.createElement('a');
        linkEl.href = url;
        linkEl.setAttribute('download', fileName);
        document.body.appendChild(linkEl);
        linkEl.click();

        linkEl.parentNode.removeChild(linkEl);
        setTimeout(() => {
          URL.revokeObjectURL(url);
        }, 1000);
      }
    };

    const csvDownloadAction = async () => {
      setLoading(true);
      updateOpenProgress(true);
      const response = await actions
        .downloadCSV()
        .then(data => checkSession(data));
      if (response.type === 'DOWNLOAD_CSV_SUCCESS') {
        const lastMonth = moment()
          .subtract(1, 'month')
          .tz('Asia/Tokyo')
          .format('YYYYMM');
        const timeStamp = moment()
          .tz('Asia/Tokyo')
          .format('YYYYMMDDHHmm');
        updateOpenProgress(false);
        setMessage('');
        setLoading(false);
        downloadCsvBlob(
          response.payload,
          `${timeStamp}_${lastMonth}_report.xlsx`
        );
      } else {
        setMessage('ごち情報ダウンロードに失敗しました。');
        setLoading(false);
      }
    };

    const reCheckStatus = async () => {
      setLoading(true);
      updateOpenProgress(true);
      let result;
      for (let i = 0; i < 5; i += 1) {
        // eslint-disable-next-line no-await-in-loop
        result = await getStatisticGochiStatusData().then(response => {
          return response;
        });
        if (result.data.status !== 1) break;
        // eslint-disable-next-line no-await-in-loop
        await new Promise(r => setTimeout(r, 10000));
      }

      console.log('result out for ', result);

      if (result.data) {
        setLoading(false);
        if (result.data.status === 1) {
          updateOpenProgress(false);
          updateOpenConfirmDialog(true);
          setMessage(
            'Report is re-running, please wait, it will take some minutes to be done.'
          );
        }

        if (result.data.status === 2) {
          setMessage('There is unexpected error when re-running report.');
        }

        if (result.data.status === 3) {
          setMessage('Re-runing report successfully.');
          getDetail();
        }
      }
    };

    const onClickReport = async () => {
      setLoading(true);
      updateOpenProgress(true);
      await actions.postStatisticsImport();

      await actions.postStatisticsGochi();
      await reCheckStatus();
    };

    const onClickBack = () => handleRedirect('/automatic-statistics');

    const {
      chargeStripeCompare,
      chargePaypayCompare,
      chargeAlipayCompare,
      chargeVeritransCompare,
      chargeAtoneCompare,
      transferStripeCompare,
      transferAmount,
      transferStripeAndGochiCompare,
      transferBackOut,
      transferBackMenuGroupOut,
      gochiAmountOut,
      sskTicketCountSummary,
      sskUserTicketDetailErrors,
      chargeNotTransferAmount,
      chargeStripeAndAllCompare,
      chargeIds,
      paypaySummaryOut,
      chargePaypayAndAllCompare,
      veritransSummaryOut,
      chargeVeritransAndAllCompare,
      chargeVeritransRefundAndAllCompare,
      atoneSummaryOut,
      chargeAtoneAndAllCompare,
      chargeAtoneRefundAndAllCompare,
      alipaySummaryOut,
      chargeAlipayAndAllCompare,
      gochiBillDeleted,
      sskChargeCountSummary,
      sskUnusedTicket,
      sskPaymentAmountCompare,
      sskPaymentAmountAndMenuCompare,
      userHoldingTickets
    } = compareData;

    return (
      <div className={classes.boxCreate}>
        <h2>Confirm report result</h2>
        <br />
        <br />

        <div className={classes.contentTable}>
          <div className={classes.titleSection}>
            1. So sánh thông tin charge từ DB payment với
            4th(stripe,paypay,alipay, veritrans, atone)
          </div>
          <div className={classes.subTitle}>
            Thông tin chênh lệch của stripe và DB payment
          </div>
          <Table className={classes.tableReport}>
            <TableHead>
              <TableRow>
                <TableCell>STT</TableCell>
                <TableCell>charge_id</TableCell>
                <TableCell>charge_amount</TableCell>
                <TableCell>status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {chargeStripeCompare && chargeStripeCompare.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5} className={classes.noData}>
                    Không có data
                  </TableCell>
                </TableRow>
              )}
              {chargeStripeCompare &&
                chargeStripeCompare.map((item, index) => (
                  <TableRow>
                    <TableCell>{index}</TableCell>
                    <TableCell>{item.chargeId}</TableCell>
                    <TableCell>{item.chargeAmount || ''}</TableCell>
                    <TableCell>{item.status || ''}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          <div className={classes.subTitle}>
            Thông tin chênh lệch của paypay và DB payment
          </div>
          <Table className={classes.tableReport}>
            <TableHead>
              <TableRow>
                <TableCell>STT</TableCell>
                <TableCell>transaction_id</TableCell>
                <TableCell>amount</TableCell>
                <TableCell>status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {chargePaypayCompare && chargePaypayCompare.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5} className={classes.noData}>
                    Không có data
                  </TableCell>
                </TableRow>
              )}
              {chargePaypayCompare &&
                chargePaypayCompare.map((item, index) => (
                  <TableRow>
                    <TableCell>{index}</TableCell>
                    <TableCell>{item.transactionId}</TableCell>
                    <TableCell>{item.chargeAmount || ''}</TableCell>
                    <TableCell>{item.status || ''}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>

          <div className={classes.subTitle}>
            Thông tin chênh lệch của Alipay và DB payment
          </div>
          <Table className={classes.tableReport}>
            <TableHead>
              <TableRow>
                <TableCell>STT</TableCell>
                <TableCell>transaction_id</TableCell>
                <TableCell>amount</TableCell>
                <TableCell>status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {chargeAlipayCompare && chargeAlipayCompare.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5} className={classes.noData}>
                    Không có data
                  </TableCell>
                </TableRow>
              )}
              {chargeAlipayCompare &&
                chargeAlipayCompare.map((item, index) => (
                  <TableRow>
                    <TableCell>{index}</TableCell>
                    <TableCell>{item.transactionId}</TableCell>
                    <TableCell>{item.chargeAmount || ''}</TableCell>
                    <TableCell>{item.status || ''}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>

          <div className={classes.subTitle}>
            Thông tin chênh lệch của veritrans và DB payment
          </div>
          <Table className={classes.tableReport}>
            <TableHead>
              <TableRow>
                <TableCell>STT</TableCell>
                <TableCell>charge_id</TableCell>
                <TableCell>amount</TableCell>
                <TableCell>status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {chargeVeritransCompare && chargeVeritransCompare.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5} className={classes.noData}>
                    Không có data
                  </TableCell>
                </TableRow>
              )}
              {chargeVeritransCompare &&
                chargeVeritransCompare.map((item, index) => (
                  <TableRow>
                    <TableCell>{index}</TableCell>
                    <TableCell>{item.chargeId}</TableCell>
                    <TableCell>{item.chargeAmount || ''}</TableCell>
                    <TableCell>{item.status || ''}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>

          <div className={classes.subTitle}>
            Thông tin chênh lệch của atone và DB payment
          </div>
          <Table className={classes.tableReport}>
            <TableHead>
              <TableRow>
                <TableCell>STT</TableCell>
                <TableCell>transaction_id</TableCell>
                <TableCell>amount</TableCell>
                <TableCell>status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {chargeAtoneCompare && chargeAtoneCompare.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5} className={classes.noData}>
                    Không có data
                  </TableCell>
                </TableRow>
              )}
              {chargeAtoneCompare &&
                chargeAtoneCompare.map((item, index) => (
                  <TableRow>
                    <TableCell>{index}</TableCell>
                    <TableCell>{item.transactionId}</TableCell>
                    <TableCell>{item.chargeAmount || ''}</TableCell>
                    <TableCell>{item.status || ''}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </div>

        <div className={classes.contentTable}>
          <div className={classes.titleSection}>
            2. So sánh tổng tiền đã transfer cho shop trong DB và stripe
            dashboard
          </div>

          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              SUM(check_total.transfer_amount+check_total_menu_group.transfered_amount):
            </div>
            <div>
              {(transferAmount.transferAmount &&
                transferAmount.transferAmount.toLocaleString()) ||
                0}
            </div>
          </div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              SUM stripe_stransfers.amount:
            </div>
            <div>
              {' '}
              {(transferAmount.stripeTransferAmount &&
                transferAmount.stripeTransferAmount.toLocaleString()) ||
                0}
            </div>
          </div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>Lệch:</div>
            <div>
              {(transferAmount.transferAmount -
                transferAmount.stripeTransferAmount &&
                (
                  transferAmount.transferAmount -
                  transferAmount.stripeTransferAmount
                ).toLocaleString()) ||
                0}
            </div>
          </div>

          <div className={classes.subTitle}>
            Thông tin chênh lệch số transfer từ stripe và DB payment
          </div>
          <Table className={classes.tableReport}>
            <TableHead>
              <TableRow>
                <TableCell>transfer_id</TableCell>
                <TableCell>stripe.transfer_amount</TableCell>
                <TableCell>payment.transfer_amount</TableCell>
                <TableCell>stripe.status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {transferStripeCompare && transferStripeCompare.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5} className={classes.noData}>
                    Không có data
                  </TableCell>
                </TableRow>
              )}
              {transferStripeCompare &&
                transferStripeCompare.map(item => (
                  <TableRow>
                    <TableCell>{item.transferId}</TableCell>
                    <TableCell>{item.stripeAmount}</TableCell>
                    <TableCell>{item.paymentAmount || ''}</TableCell>
                    <TableCell>{item.status || ''}</TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>

          <div className={classes.subTitle}>
            Thông tin chênh lệch số transfer từ stripe và DB gcms
          </div>

          <Table className={[classes.tableReport, classes.marginTop]}>
            <TableHead>
              <TableRow>
                <TableCell>gochi_bill_id</TableCell>
                <TableCell>transfer_id</TableCell>
                <TableCell>{'cột A\n(stripe dashboard)'}</TableCell>
                <TableCell>{'cột B\n(gochi_bill.transfer_amount)'}</TableCell>
                <TableCell>Chênh lệch</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {transferStripeAndGochiCompare &&
                transferStripeAndGochiCompare.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={5} className={classes.noData}>
                      Không có data
                    </TableCell>
                  </TableRow>
                )}
              {transferStripeAndGochiCompare &&
                transferStripeAndGochiCompare.map(item => {
                  const diff = item.stripeAmount - item.gochiAmount;
                  if (!diff) return null;
                  return (
                    <TableRow>
                      <TableCell>{item.gochiBillId}</TableCell>
                      <TableCell>{item.transferId}</TableCell>
                      <TableCell>{item.stripeAmount}</TableCell>
                      <TableCell>{item.gochiAmount || ''}</TableCell>
                      <TableCell>{diff.toFixed(2)}</TableCell>
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
        </div>
        <div className={classes.contentTable}>
          <div className={classes.titleSection}>
            3. So sánh tổng tiền còn lại chưa transfer hết cho shop với những
            gochi mua tại shop và đã transfer 1 lần với cột transfer_back_amount
            trong DB
          </div>
          <Table className={classes.tableReport}>
            <TableHead>
              <TableRow>
                <TableCell>SUM(check_total.transfer_back_amount)</TableCell>
                <TableCell>SUM back_to_shop.remain_amount</TableCell>
                <TableCell>Lệch</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  {(transferBackOut.transferBackAmount &&
                    transferBackOut.transferBackAmount.toLocaleString()) ||
                    0}
                </TableCell>
                <TableCell>
                  {(transferBackOut.remainAmount &&
                    transferBackOut.remainAmount.toLocaleString()) ||
                    0}
                </TableCell>
                <TableCell>
                  {(transferBackOut.transferBackAmount -
                    transferBackOut.remainAmount &&
                    (
                      transferBackOut.transferBackAmount -
                      transferBackOut.remainAmount
                    ).toLocaleString()) ||
                    0}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
          <Table className={[classes.tableReport, classes.marginTop]}>
            <TableHead>
              <TableRow>
                <TableCell>
                  SUM(check_total_menu_group.transfer_back_amount)
                </TableCell>
                <TableCell>SUM back_to_shop_menu_group.remain_amount</TableCell>
                <TableCell>Lệch</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>
                  {(transferBackMenuGroupOut.transferBackAmount &&
                    transferBackMenuGroupOut.transferBackAmount.toLocaleString()) ||
                    0}
                </TableCell>
                <TableCell>
                  {(transferBackMenuGroupOut.remainAmount &&
                    transferBackMenuGroupOut.remainAmount.toLocaleString()) ||
                    0}
                </TableCell>
                <TableCell>
                  {(transferBackMenuGroupOut.transferBackAmount -
                    transferBackMenuGroupOut.remainAmount &&
                    (
                      transferBackMenuGroupOut.transferBackAmount -
                      transferBackMenuGroupOut.remainAmount
                    ).toLocaleString()) ||
                    0}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </div>
        <div className={classes.contentTable}>
          <div className={classes.titleSection}>
            4. So sánh tổng tiền cần phải chuyển cho shop (của những gochi mua
            tại shop , chưa transfer lần nào) với những gochi mua tại shop ở các
            bảng thành phần (chưa transfer lần nào)
          </div>
          <div className={classes.boxSum}>
            <div className={classes.boxSumTitle}>
              SUM cột (amount + tax_amount - fee_shop_amount - transfer_amount -
              transfer_back_amount)
            </div>
            <div className={classes.boxSumData}>
              {(gochiAmountOut.gochiCheckAmount &&
                gochiAmountOut.gochiCheckAmount.toLocaleString()) ||
                0}
            </div>
          </div>
          <div className={classNames(classes.boxSum, classes.boxSumBorder)}>
            <div className={classes.boxSumTitle}>
              SUM cột (amount + tax_amount - fee_shop_amount) của:
              <div>- stripe</div>
              <div>- paypay</div>
              <div>- alipay</div>
              <div>- veritrans</div>
              <div>- atone</div>
              <div>- happy_project</div>
              <div>- self_checkout</div>
            </div>
            <div className={classes.boxSumData}>
              {(gochiAmountOut.gochiAmount &&
                gochiAmountOut.gochiAmount.toLocaleString()) ||
                0}
            </div>
          </div>
          <div className={classes.box3_bottom}>
            <div>Lệch</div>
            <div className={classes.box3_bottom_data}>
              {(gochiAmountOut.gochiCheckAmount - gochiAmountOut.gochiAmount &&
                (
                  gochiAmountOut.gochiCheckAmount - gochiAmountOut.gochiAmount
                ).toLocaleString()) ||
                0}
            </div>
          </div>
        </div>

        <div className={classes.contentTable}>
          <div className={classes.titleSection}>
            5. So sánh data ở DB của từng hệ thống shashoku với data trong bảng
            shashoku_ticket:
          </div>
          <Table className={classes.tableReport}>
            <TableHead>
              <TableRow>
                <TableCell>SystemID</TableCell>
                <TableCell>shashoku DB(user_ticket)</TableCell>
                <TableCell>gcms DB(shashoku_ticket)</TableCell>
                <TableCell>Chênh lệch</TableCell>
                <TableCell>Ngày có data lệch</TableCell>
              </TableRow>
            </TableHead>
            {sskTicketCountSummary.length > 0 ? (
              sskTicketCountSummary.map(item => (
                <>
                  <TableRow>
                    <TableCell>{item.systemId}</TableCell>
                    <TableCell>
                      {(item.shashokuCount &&
                        item.shashokuCount.toLocaleString()) ||
                        0}
                    </TableCell>
                    <TableCell>
                      {(item.gcmsCount && item.gcmsCount.toLocaleString()) || 0}
                    </TableCell>
                    <TableCell>
                      {(item.shashokuCount - item.gcmsCount &&
                        (
                          item.shashokuCount - item.gcmsCount
                        ).toLocaleString()) ||
                        0}
                    </TableCell>
                    <TableCell>{item.date}</TableCell>
                  </TableRow>
                </>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} className={classes.noData}>
                  Không có data
                </TableCell>
              </TableRow>
            )}
          </Table>
        </div>

        <div className={classes.contentTable}>
          <div className={classes.titleSection}>
            6. Những user_ticket_detail có ghi nhận trạng thái lỗi (ở N hệ thống
            shashoku)
          </div>
          <Table className={classes.tableReport}>
            <TableHead>
              <TableRow>
                <TableCell>SystemID</TableCell>
                <TableCell>user_ticket_detail_id</TableCell>
                <TableCell>shop_name</TableCell>
                <TableCell>menu_name</TableCell>
                <TableCell>shop_id</TableCell>
                <TableCell>menu_id</TableCell>
                <TableCell>amount</TableCell>
                <TableCell>tax_amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sskUserTicketDetailErrors.length > 0 ? (
                sskUserTicketDetailErrors.map(item => (
                  <>
                    <TableRow>
                      <TableCell>{item.systemId}</TableCell>
                      <TableCell>{item.userTicketDetailId}</TableCell>
                      <TableCell>{item.shopName}</TableCell>
                      <TableCell>{item.menuName}</TableCell>
                      <TableCell>{item.shopId}</TableCell>
                      <TableCell>{item.menuId}</TableCell>
                      <TableCell>
                        {(item.amount && item.amount.toLocaleString()) || 0}
                      </TableCell>
                      <TableCell>
                        {(item.taxAmount && item.taxAmount.toLocaleString()) ||
                          0}
                      </TableCell>
                    </TableRow>
                  </>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={8} className={classes.noData}>
                    Không có data
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
        <div className={classes.contentTable}>
          <div className={classes.titleSection}>
            7. Check tổng charge bên stripe = tổng charge stripe của gochi_bill
            + tổng charge stripe của shashoku
          </div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              tổng charge bên stripe:
            </div>
            <div>
              {chargeNotTransferAmount.chargeStripeNotTransfer
                ? chargeNotTransferAmount.chargeStripeNotTransfer
                : 0}
            </div>
          </div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              tổng charge stripe của gochi_bill:
            </div>
            <div>{chargeNotTransferAmount.chargeGochiNotTransfer}</div>
          </div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              tổng charge stripe của shashoku:
            </div>
            <div>
              {chargeNotTransferAmount.chargeSskNotTransfer +
                chargeNotTransferAmount.chargeSskDonateNotTransfer}
            </div>
          </div>
          <Table className={classes.tableReport}>
            <TableHead>
              <TableRow>
                <TableCell>charge_id</TableCell>
                <TableCell>merchant_payment_id</TableCell>
                <TableCell>cột A (stripe dashboard)</TableCell>
                <TableCell>cột B (gochi_bill.charge_amount)</TableCell>
                <TableCell>
                  cột C (user_ticket_payment_id.payment_amount)
                </TableCell>
                <TableCell>donate_payment.payment_amount</TableCell>
                <TableCell>Chênh lệch = A-B-C-D</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {chargeStripeAndAllCompare.length > 0 ? (
                chargeStripeAndAllCompare.map(item => {
                  const diff =
                    item.stripeAmount -
                    item.gochiBillAmount -
                    item.userTicketAmount -
                    item.donateAmount;
                  if (!diff) return null;
                  return (
                    <>
                      <TableRow>
                        <TableCell>{item.chargeId}</TableCell>
                        <TableCell>{item.merchantPaymentId}</TableCell>
                        <TableCell>
                          {(item.stripeAmount &&
                            item.stripeAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(item.gochiBillAmount &&
                            item.gochiBillAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(item.userTicketAmount &&
                            item.userTicketAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(item.donateAmount &&
                            item.donateAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(diff && diff.toLocaleString()) || 0}
                        </TableCell>
                      </TableRow>
                    </>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={5} className={classes.noData}>
                    Không có data
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
        <div className={classes.contentTable}>
          <div className={classes.titleSection}>
            8. Check stripe transfer: list những transferId không có chargeId
            tương ứng
          </div>
          {chargeIds.map(item => (
            <>
              <div>{item}</div>
            </>
          ))}
        </div>

        <div className={classes.contentTable}>
          <div className={classes.titleSection}>9. Check paypay</div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              tổng charge bên paypay:
            </div>
            <div>
              {paypaySummaryOut.paypayTransactionAmount
                ? paypaySummaryOut.paypayTransactionAmount
                : 0}
            </div>
          </div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              tổng charge paypay của gochi_bill:
            </div>
            <div>{paypaySummaryOut.paypayGochiAmount}</div>
          </div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              tổng charge paypay của shashoku:
            </div>
            <div>{paypaySummaryOut.paypaySskAmount}</div>
          </div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              tổng donate paypay của shashoku:
            </div>
            <div>{paypaySummaryOut.paypaySskDonateAmount}</div>
          </div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              tổng gochi charge của gochi charge log:
            </div>
            <div>{paypaySummaryOut.paypayGochiChargeAmount}</div>
          </div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              tổng gochi kid của gochi kid donate log:
            </div>
            <div>{paypaySummaryOut.paypayGochiKidAmount}</div>
          </div>
          <Table className={classes.tableReport}>
            <TableHead>
              <TableRow>
                <TableCell>charge_id</TableCell>
                <TableCell>merchant_payment_id</TableCell>
                <TableCell>cột A (stripe dashboard)</TableCell>
                <TableCell>cột B (gochi_bill.charge_amount)</TableCell>
                <TableCell>
                  cột C (user_ticket_payment_id.payment_amount)
                </TableCell>
                <TableCell>donate_payment.payment_amount</TableCell>
                <TableCell>gochi_charge_log.charge_amount</TableCell>
                <TableCell>gochi_kid_donate_log.gochi_kid</TableCell>
                <TableCell>Chênh lệch = A-B-C-D-E-F</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {chargePaypayAndAllCompare.length > 0 ? (
                chargePaypayAndAllCompare.map(item => {
                  const diff =
                    item.stripeAmount -
                    item.gochiBillAmount -
                    item.userTicketAmount -
                    item.donateAmount -
                    item.gochiChargeAmount -
                    item.gochiKidAmount;
                  if (!diff) return null;
                  return (
                    <>
                      <TableRow>
                        <TableCell>{item.chargeId}</TableCell>
                        <TableCell>{item.merchantPaymentId}</TableCell>
                        <TableCell>
                          {(item.stripeAmount &&
                            item.stripeAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(item.gochiBillAmount &&
                            item.gochiBillAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(item.userTicketAmount &&
                            item.userTicketAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(item.donateAmount &&
                            item.donateAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(item.gochiChargeAmount &&
                            item.gochiChargeAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(item.gochiKidAmount &&
                            item.gochiKidAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(diff && diff.toLocaleString()) || 0}
                        </TableCell>
                      </TableRow>
                    </>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={8} className={classes.noData}>
                    Không có data
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>

        {/* Mục 10 */}

        <div className={classes.contentTable}>
          <div className={classes.titleSection}>10. Check alipay</div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              tổng charge bên alipay:
            </div>
            <div>
              {alipaySummaryOut.alipayTransactionAmount
                ? alipaySummaryOut.alipayTransactionAmount
                : 0}
            </div>
          </div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              tổng charge alipay của gochi_bill:
            </div>
            <div>{alipaySummaryOut.alipayGochiAmount}</div>
          </div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              tổng charge alipay của shashoku:
            </div>
            <div>{alipaySummaryOut.alipaySskAmount}</div>
          </div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              tổng donate alipay của shashoku:
            </div>
            <div>{alipaySummaryOut.alipaySskDonateAmount}</div>
          </div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              tổng gochi charge của gochi charge log:
            </div>
            <div>{alipaySummaryOut.alipayGochiChargeAmount}</div>
          </div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              tổng gochi kid của gochi kid donate log:
            </div>
            <div>{alipaySummaryOut.alipayGochiKidAmount}</div>
          </div>
          <Table className={classes.tableReport}>
            <TableHead>
              <TableRow>
                <TableCell>charge_id</TableCell>
                <TableCell>merchant_payment_id</TableCell>
                <TableCell>cột A (alipay dashboard)</TableCell>
                <TableCell>cột B (gochi_bill.charge_amount)</TableCell>
                <TableCell>
                  cột C (user_ticket_payment_id.payment_amount)
                </TableCell>
                <TableCell>donate_payment.payment_amount</TableCell>
                <TableCell>gochi_charge_log.charge_amount</TableCell>
                <TableCell>gochi_kid_donate_log.gochi_kid_amount</TableCell>
                <TableCell>Chênh lệch = A-B-C-D-E-F</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {chargeAlipayAndAllCompare &&
              chargeAlipayAndAllCompare.length > 0 ? (
                chargeAlipayAndAllCompare.map(item => {
                  const diff =
                    item.alipayAmount -
                    item.gochiBillAmount -
                    item.userTicketAmount -
                    item.donateAmount -
                    item.gochiChargeAmount -
                    item.gochiKidAmount;
                  if (!diff) return null;
                  return (
                    <>
                      <TableRow>
                        <TableCell>{item.chargeId}</TableCell>
                        <TableCell>{item.merchantPaymentId}</TableCell>
                        <TableCell>
                          {(item.alipayAmount &&
                            item.alipayAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(item.gochiBillAmount &&
                            item.gochiBillAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(item.userTicketAmount &&
                            item.userTicketAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(item.donateAmount &&
                            item.donateAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(item.gochiChargeAmount &&
                            item.gochiChargeAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(item.gochiKidAmount &&
                            item.gochiKidAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(diff && diff.toLocaleString()) || 0}
                        </TableCell>
                      </TableRow>
                    </>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={8} className={classes.noData}>
                    Không có data
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>

        {/* Mục 11 */}

        <div className={classes.contentTable}>
          <div className={classes.titleSection}>
            11. Thông tin list bill đã xóa
          </div>
          <Table className={classes.tableReport}>
            <TableHead>
              <TableRow>
                <TableCell>payment_type</TableCell>
                <TableCell>charge_amount</TableCell>
                <TableCell>transfer_amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {gochiBillDeleted.length > 0 ? (
                gochiBillDeleted.map(item => {
                  return (
                    <>
                      <TableRow>
                        <TableCell>{item.paymentType}</TableCell>
                        <TableCell>
                          {(item.chargeAmount &&
                            item.chargeAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(item.transferAmount &&
                            item.transferAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                      </TableRow>
                    </>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={5} className={classes.noData}>
                    Không có data
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>

        <div className={classes.contentTable}>
          <div className={classes.titleSection}>
            12.1 So sánh tổng charge ở các hệ thống shashoku với tổng charge ở
            gcms.shashoku_ticket
          </div>
          <Table className={classes.tableReport}>
            <TableHead>
              <TableRow>
                <TableCell>SystemID</TableCell>
                <TableCell>sskCharge</TableCell>
                <TableCell>gcmsCharge</TableCell>
                <TableCell>Chênh lệch</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sskChargeCountSummary.length > 0 ? (
                sskChargeCountSummary.map(item => {
                  const diff = item.sskCharge - item.gcmsCharge;
                  if (!diff) return null;
                  return (
                    <>
                      <TableRow>
                        <TableCell>{item.systemId}</TableCell>
                        <TableCell>
                          {(item.sskCharge &&
                            item.sskCharge.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(item.gcmsCharge &&
                            item.gcmsCharge.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(diff && diff.toLocaleString()) || 0}
                        </TableCell>
                      </TableRow>
                    </>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={5} className={classes.noData}>
                    Không có data
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

          <div className={classes.subTitleSection}>
            12.2 Những charge success bên shashoku nhưng bị unused
          </div>

          <Table className={classes.tableReport}>
            <TableHead>
              <TableRow>
                <TableCell>user_ticket_id</TableCell>
                <TableCell>from_system_id</TableCell>
                <TableCell>created_at</TableCell>
                <TableCell>updated_at</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sskUnusedTicket.length > 0 ? (
                sskUnusedTicket.map(item => {
                  return (
                    <>
                      <TableRow>
                        <TableCell>{item.userTicketId}</TableCell>
                        <TableCell>{item.systemId}</TableCell>
                        <TableCell>{item.createdAt}</TableCell>
                        <TableCell>{item.updatedAt}</TableCell>
                      </TableRow>
                    </>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={5} className={classes.noData}>
                    Không có data
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

          <div className={classes.subTitleSection}>
            12.3 So sánh tiền tổng charge trong shashoku: compare
            user_ticket_payment với bảng user_ticket
          </div>

          <Table className={classes.tableReport}>
            <TableHead>
              <TableRow>
                <TableCell>system_id</TableCell>
                <TableCell>user_ticket_payment_id</TableCell>
                <TableCell>cột A (user_ticket_payment.charge_amount)</TableCell>
                <TableCell>cột B (SUM (user_ticket.charge_amount))</TableCell>
                <TableCell>Chênh lệch A-B</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sskPaymentAmountCompare.length > 0 ? (
                sskPaymentAmountCompare.map(item => {
                  return (
                    <>
                      <TableRow>
                        <TableCell>{item.systemId}</TableCell>
                        <TableCell>{item.userTicketPaymentId}</TableCell>
                        <TableCell>{item.paymentChargeAmount}</TableCell>
                        <TableCell>{item.userTicketChargeAmount}</TableCell>
                        <TableCell>
                          {item.paymentChargeAmount -
                            item.userTicketChargeAmount}
                        </TableCell>
                      </TableRow>
                    </>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={5} className={classes.noData}>
                    Không có data
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>

          <div className={classes.subTitleSection}>
            12.4 So sánh tiền tổng tiền used_price + payment_amount so với giá
            menu
          </div>

          <Table className={classes.tableReport}>
            <TableHead>
              <TableRow>
                <TableCell>menu_price</TableCell>
                <TableCell>(used_price + payment_amount)</TableCell>
                <TableCell>user_ticket_detail_id</TableCell>
                <TableCell>from_system_id</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {sskPaymentAmountAndMenuCompare.length > 0 ? (
                sskPaymentAmountAndMenuCompare.map(item => {
                  return (
                    <>
                      <TableRow>
                        <TableCell>{item.menuPrice}</TableCell>
                        <TableCell>{item.usedPrice}</TableCell>
                        <TableCell>{item.userTicketDetailId}</TableCell>
                        <TableCell>{item.systemId}</TableCell>
                      </TableRow>
                    </>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={5} className={classes.noData}>
                    Không có data
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
        <div className={classes.contentTable}>
          <div className={classes.titleSection}>
            12.5 Những user_ticket bị hold
          </div>
          <Table className={classes.tableReport}>
            <TableHead>
              <TableRow>
                <TableCell>SystemID</TableCell>
                <TableCell>user_ticket_id</TableCell>
                <TableCell>ticket_id</TableCell>
                <TableCell>user_id</TableCell>
                <TableCell>shop_id</TableCell>
                <TableCell>menu_id</TableCell>
                <TableCell>used_price</TableCell>
                <TableCell>payment_amount</TableCell>
                <TableCell>charge_amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {userHoldingTickets.length > 0 ? (
                userHoldingTickets.map(item => (
                  <>
                    <TableRow>
                      <TableCell>{item.systemId}</TableCell>
                      <TableCell>{item.userTicketId}</TableCell>
                      <TableCell>{item.ticketId}</TableCell>
                      <TableCell>{item.userId}</TableCell>
                      <TableCell>{item.shopId}</TableCell>
                      <TableCell>{item.menuId}</TableCell>
                      <TableCell>
                        {(item.usedPrice && item.usedPrice.toLocaleString()) ||
                          0}
                      </TableCell>
                      <TableCell>
                        {(item.paymentAmount &&
                          item.paymentAmount.toLocaleString()) ||
                          0}
                      </TableCell>
                      <TableCell>
                        {(item.chargeAmount &&
                          item.chargeAmount.toLocaleString()) ||
                          0}
                      </TableCell>
                    </TableRow>
                  </>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={9} className={classes.noData}>
                    Không có data
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
        {/* Mục 13 */}
        <div className={classes.contentTable}>
          <div className={classes.titleSection}>13. Check veritrans</div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              tổng charge bên veritrans:
            </div>
            <div>
              {veritransSummaryOut.veritransTransactionAmount
                ? veritransSummaryOut.veritransTransactionAmount
                : 0}
            </div>
          </div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              tổng refund veritrans :
            </div>
            <div>
              {veritransSummaryOut.veritransTransactionRefundAmount
                ? veritransSummaryOut.veritransTransactionRefundAmount
                : 0}
            </div>
          </div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              tổng charge veritrans của gochi_bill:
            </div>
            <div>{veritransSummaryOut.veritransGochiAmount}</div>
          </div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              tổng charge veritrans của shashoku:
            </div>
            <div>{veritransSummaryOut.veritransSskAmount}</div>
          </div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              tổng donate veritrans của shashoku:
            </div>
            <div>{veritransSummaryOut.veritransSskDonateAmount}</div>
          </div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              tổng gochi charge của gochi charge log:
            </div>
            <div>{veritransSummaryOut.veritransGochiChargeAmount}</div>
          </div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              tổng gochi kid của gochi kid donate log:
            </div>
            <div>{veritransSummaryOut.veritransGochiKidAmount}</div>
          </div>
          <Table className={classes.tableReport}>
            <TableHead>
              <TableRow>
                <TableCell>charge_id</TableCell>
                <TableCell>merchant_payment_id</TableCell>
                <TableCell>cột A (stripe dashboard)</TableCell>
                <TableCell>cột B (gochi_bill.charge_amount)</TableCell>
                <TableCell>
                  cột C (user_ticket_payment_id.payment_amount)
                </TableCell>
                <TableCell>donate_payment.payment_amount</TableCell>
                <TableCell>gochi_charge_log.charge_amount</TableCell>
                <TableCell>gochi_kid_donate_log.gochi_kid_amount</TableCell>
                <TableCell>Chênh lệch = A-B-C-D-E-F</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {chargeVeritransAndAllCompare.length > 0 ? (
                chargeVeritransAndAllCompare.map(item => {
                  const diff =
                    item.veritransAmount -
                    item.gochiBillAmount -
                    item.userTicketAmount -
                    item.donateAmount -
                    item.gochiChargeAmount -
                    item.gochiKidAmount;
                  if (!diff) return null;
                  return (
                    <>
                      <TableRow>
                        <TableCell>{item.chargeId}</TableCell>
                        <TableCell>{item.merchantPaymentId}</TableCell>
                        <TableCell>
                          {(item.veritransAmount &&
                            item.veritransAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(item.gochiBillAmount &&
                            item.gochiBillAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(item.userTicketAmount &&
                            item.userTicketAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(item.donateAmount &&
                            item.donateAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(item.gochiChargeAmount &&
                            item.gochiChargeAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(item.gochiKidAmount &&
                            item.gochiKidAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(diff && diff.toLocaleString()) || 0}
                        </TableCell>
                      </TableRow>
                    </>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={8} className={classes.noData}>
                    Không có data
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              Bảng refund và có gochi:
            </div>
          </div>
          <Table className={classes.tableReport}>
            <TableHead>
              <TableRow>
                <TableCell>charge_id</TableCell>
                <TableCell>merchant_payment_id</TableCell>
                <TableCell>cột A (stripe dashboard)</TableCell>
                <TableCell>cột B (gochi_bill.charge_amount)</TableCell>
                <TableCell>
                  cột C (user_ticket_payment_id.payment_amount)
                </TableCell>
                <TableCell>donate_payment.payment_amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {chargeVeritransRefundAndAllCompare.length > 0 ? (
                chargeVeritransRefundAndAllCompare.map(item => {
                  return (
                    <>
                      <TableRow>
                        <TableCell>{item.chargeId}</TableCell>
                        <TableCell>{item.merchantPaymentId}</TableCell>
                        <TableCell>
                          {(item.veritransAmount &&
                            item.veritransAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(item.gochiBillAmount &&
                            item.gochiBillAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(item.userTicketAmount &&
                            item.userTicketAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(item.donateAmount &&
                            item.donateAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                      </TableRow>
                    </>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={5} className={classes.noData}>
                    Không có data
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>

        {/* Mục 14 */}
        <div className={classes.contentTable}>
          <div className={classes.titleSection}>14. Check atone</div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              tổng charge bên atone:
            </div>
            <div>
              {atoneSummaryOut && atoneSummaryOut.atoneTransactionAmount
                ? atoneSummaryOut.atoneTransactionAmount
                : 0}
            </div>
          </div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              tổng charge atone của gochi_bill:
            </div>
            <div>{atoneSummaryOut && atoneSummaryOut.atoneGochiAmount}</div>
          </div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              tổng charge atone của shashoku:
            </div>
            <div>{atoneSummaryOut && atoneSummaryOut.atoneSskAmount}</div>
          </div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              tổng donate atone của shashoku:
            </div>
            <div>{atoneSummaryOut && atoneSummaryOut.atoneSskDonateAmount}</div>
          </div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              tổng gochi charge của gochi charge log:
            </div>
            <div>
              {atoneSummaryOut && atoneSummaryOut.atoneGochiChargeAmount}
            </div>
          </div>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>
              tổng gochi kid của gochi kid donate log:
            </div>
            <div>{atoneSummaryOut && atoneSummaryOut.atoneGochiKidAmount}</div>
          </div>
          <Table className={classes.tableReport}>
            <TableHead>
              <TableRow>
                <TableCell>charge_id</TableCell>
                <TableCell>merchant_payment_id</TableCell>
                <TableCell>cột A (atone dashboard)</TableCell>
                <TableCell>cột B (gochi_bill.charge_amount)</TableCell>
                <TableCell>
                  cột C (user_ticket_payment_id.payment_amount)
                </TableCell>
                <TableCell>donate_payment.payment_amount</TableCell>
                <TableCell>gochi_charge_log.charge_amount</TableCell>
                <TableCell>gochi_kid_donate_log.gochi_kid_amount</TableCell>
                <TableCell>Chênh lệch = A-B-C-D-E-F</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {chargeAtoneAndAllCompare &&
              chargeAtoneAndAllCompare.length > 0 ? (
                chargeAtoneAndAllCompare.map(item => {
                  const diff =
                    item.atoneAmount -
                    item.gochiBillAmount -
                    item.userTicketAmount -
                    item.donateAmount -
                    item.gochiChargeAmount -
                    item.gochiKidAmount;
                  if (!diff) return null;
                  return (
                    <>
                      <TableRow>
                        <TableCell>{item.chargeId}</TableCell>
                        <TableCell>{item.merchantPaymentId}</TableCell>
                        <TableCell>
                          {(item.atoneAmount &&
                            item.atoneAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(item.gochiBillAmount &&
                            item.gochiBillAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(item.userTicketAmount &&
                            item.userTicketAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(item.donateAmount &&
                            item.donateAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(item.gochiChargeAmount &&
                            item.gochiChargeAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(item.gochiKidAmount &&
                            item.gochiKidAmount.toLocaleString()) ||
                            0}
                        </TableCell>
                        <TableCell>
                          {(diff && diff.toLocaleString()) || 0}
                        </TableCell>
                      </TableRow>
                    </>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={8} className={classes.noData}>
                    Không có data
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          <div className={classes.check_sum}>
            <div className={classes.title_check_sum}>Bảng refund:</div>
          </div>
          <Table className={classes.tableReport}>
            <TableHead>
              <TableRow>
                <TableCell>merchant_Id</TableCell>
                <TableCell>refund_at</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {chargeAtoneRefundAndAllCompare &&
              chargeAtoneRefundAndAllCompare.length > 0 ? (
                chargeAtoneRefundAndAllCompare.map(item => {
                  return (
                    <>
                      <TableRow>
                        <TableCell>{item.merchantId}</TableCell>
                        <TableCell>{item.refundAt}</TableCell>
                      </TableRow>
                    </>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={5} className={classes.noData}>
                    Không có data
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>

        <div className={classes.listBtn}>
          <Button
            variant="contained"
            color="primary"
            className={classes.btnRun}
            onClick={onClickBack}
            size="large"
          >
            Back
          </Button>
          <Button
            variant="contained"
            color="primary"
            className={classes.btnRun}
            onClick={csvDownloadAction}
            size="large"
          >
            Export final report
          </Button>
          <Button
            variant="contained"
            color="primary"
            className={classes.btnRun}
            onClick={onClickReport}
            size="large"
          >
            Re-run report
          </Button>
          <Button
            variant="contained"
            color="primary"
            className={classes.btnRun}
            styles="marginLeft: 10px;"
            onClick={reCheckStatus}
            size="sm"
          >
            Re-check runing report status
          </Button>
        </div>
        <ProgressDialog
          openProgress={openProgress}
          progressOkAction={progressOkAction}
          loading={loading}
          resultMessage={message}
        />
        <ProgressDialog
          openProgress={comparing}
          progressOkAction={progressOkAction}
          loading={comparing}
          resultMessage={message}
        />
        <Dialog
          open={openConfirmDialog}
          onClose={() => {
            updateOpenConfirmDialog(false);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent>
            <p>{message}</p>
          </DialogContent>
          <DialogActions>
            <CancelButton
              onClickAction={() => {
                updateOpenConfirmDialog(false);
              }}
              color="default"
            />
            <Button
              variant="contained"
              color="primary"
              className={classes.btnRun}
              styles="marginLeft: 10px;"
              onClick={reCheckStatus}
              size="sm"
            >
              Re-check runing report status
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
